export function setGTagScripts(eventId) {
  if (!eventId) {
    return;
  }

  // green energy tricity
  if (eventId === 1488) {
    const headScript = document.createElement('script');
    headScript.innerHTML = `
      <!-- Google Tag Manager -->
      (function(w,d,s,l,i){
        w[l]=w[l]||[];
        w[l].push({
          'gtm.start': new Date().getTime(),
          event:'gtm.js'
        });
        var f=d.getElementsByTagName(s)[0],
          j=d.createElement(s),
          dl=l!='dataLayer'?'&l='+l:'';
        j.async=true;
        j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;
        f.parentNode.insertBefore(j,f);
      })(window,document,'script','dataLayer','GTM-N9HSBMKL');
    `;
    document.head.appendChild(headScript);

    // Google Tag Manager - body noscript
    const bodyNoScript = document.createElement('noscript');
    bodyNoScript.innerHTML = `
      <iframe src="https://www.googletagmanager.com/ns.html?id=GTM-N9HSBMKL"
        height="0" width="0" style="display:none;visibility:hidden"></iframe>
    `;
    document.body.appendChild(bodyNoScript);
  } else if (eventId === 1441) {
    const headScript = document.createElement('script');
    headScript.innerHTML = `<!-- Google Tag Manager -->
    (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
    new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
    j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
    'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
    })(window,document,'script','dataLayer','GTM-K3RC3SR2');
    <!-- End Google Tag Manager -->`;
    document.head.appendChild(headScript);

    // Google Tag Manager - body noscript
    const bodyNoScript = document.createElement('noscript');
    bodyNoScript.innerHTML = `<iframe src="https://www.googletagmanager.com/ns.html?id=GTM-K3RC3SR2"
    height="0" width="0" style="display:none;visibility:hidden"></iframe>`;
    document.body.appendChild(bodyNoScript);
  } else if (eventId === 1538) {
    const headScript = document.createElement('script');
    headScript.innerHTML = `<!-- Google Tag Manager -->
    (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
    new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
    j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
    'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
    })(window,document,'script','dataLayer','GTM-PCZV9DGB');
    <!-- End Google Tag Manager -->`;
    document.head.appendChild(headScript);

    // Google Tag Manager - body noscript
    const bodyNoScript = document.createElement('noscript');
    bodyNoScript.innerHTML = `<iframe src="https://www.googletagmanager.com/ns.html?id=GTM-PCZV9DGB"
    height="0" width="0" style="display:none;visibility:hidden"></iframe>`;
    document.body.appendChild(bodyNoScript);
  } else if (eventId === 1468) {
    const headScript = document.createElement('script');
    headScript.innerHTML = `<!-- Google Tag Manager -->
    (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
    new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
    j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
    'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
    })(window,document,'script','dataLayer','GTM-TLB8GD62');
    <!-- End Google Tag Manager -->`;
    document.head.appendChild(headScript);

    // Google Tag Manager - body noscript
    const bodyNoScript = document.createElement('noscript');
    bodyNoScript.innerHTML = `<iframe src="https://www.googletagmanager.com/ns.html?id=GTM-TLB8GD62"
    height="0" width="0" style="display:none;visibility:hidden"></iframe>`;
    document.body.appendChild(bodyNoScript);
  } else if (eventId === 1643) {
    const gtagScript = document.createElement('script');
    gtagScript.async = true;
    gtagScript.src = 'https://www.googletagmanager.com/gtag/js?id=G-CNLTCPQ1PR';
    document.head.appendChild(gtagScript);

    gtagScript.onload = () => {
        window.dataLayer = window.dataLayer || [];
      // eslint-disable-next-line no-undef
        function gtag(){ dataLayer.push(arguments); }
        gtag('js', new Date());
        gtag('config', 'G-CNLTCPQ1PR');
    };

    // Dodanie elementu noscript
    const headScript = document.createElement('script');
    headScript.innerHTML = `!function(f,b,e,v,n,t,s)
    {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
    n.callMethod.apply(n,arguments):n.queue.push(arguments)};
    if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
    n.queue=[];t=b.createElement(e);t.async=!0;
    t.src=v;s=b.getElementsByTagName(e)[0];
    s.parentNode.insertBefore(t,s)}(window, document,'script',
    'https://connect.facebook.net/en_US/fbevents.js');
    fbq('init', '906293378296373');
    fbq('track', 'PageView');`;
    document.head.appendChild(headScript);

    const bodyNoScript = document.createElement('noscript');
    bodyNoScript.innerHTML = `<img height="1" width="1" style="display:none"
    src="https://www.facebook.com/tr?id=906293378296373&ev=PageView&noscript=1"/>`;
    document.body.appendChild(bodyNoScript);
  }
}
